import {
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle,
} from "lucide-react";
import SectionCard from "@/components/SectionCard";

const iconMap = {
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle,
};

export default function PanelAcciones({ acciones, color }) {
  return (
    <SectionCard
      title="Acciones recomendadas"
      subtitle="Intervenciones sugeridas"
      testid="panel-acciones"
    >
      <div className="space-y-3">
        {acciones.map((a, i) => {
          const Icon = iconMap[a.icono] || Circle;
          return (
            <div
              key={i}
              className="flex items-start gap-3 p-3 rounded-xl border border-slate-200 hover:bg-slate-50 transition"
            >
              <div
                className="h-9 w-9 rounded-lg flex items-center justify-center text-white shrink-0 shadow-sm"
                style={{ backgroundColor: color }}
              >
                <Icon className="w-4 h-4" />
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">{a.titulo}</div>
                <div className="text-xs text-slate-500 mt-0.5">{a.descripcion}</div>
              </div>
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
}
